'use client'

import {
  CheckCircle2,
  Code2,
  FileText,
  Globe,
  Headphones,
  LineChart,
  Package,
  ShieldCheck,
  Smartphone,
  TrendingUp,
  Users,
} from 'lucide-react'
import React from 'react'

interface ServiceResultsProps {
  results: Array<{ name: string; desc: string }>
  gradient: string
}

// Icon Mapping Helper
const getIcon = (name: string) => {
  const lower = name.toLowerCase()
  if (lower.includes('продукт') || lower.includes('product')) return Package
  if (lower.includes('документ')) return FileText
  if (lower.includes('код') || lower.includes('source')) return Code2
  if (lower.includes('обучение') || lower.includes('team')) return Users
  if (lower.includes('гарантия') || lower.includes('warranty')) return ShieldCheck
  if (lower.includes('поддержка') || lower.includes('support')) return Headphones

  // Extra fallbacks for other services
  if (lower.includes('аналитика')) return LineChart
  if (lower.includes('дизайн')) return CheckCircle2
  if (lower.includes('mobile')) return Smartphone
  if (lower.includes('web')) return Globe
  if (lower.includes('рост')) return TrendingUp

  return CheckCircle2
}

export default function ServiceResults({ results, gradient }: ServiceResultsProps) {
  return (
    <section className="relative z-10 py-12 sm:py-16 lg:py-20">
      <h2 className="home-title mb-8 sm:mb-12">Результат — что вы получите</h2>

      <div className="grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {results.map((item, i) => {
          const Icon = getIcon(item.name)

          return (
            <div key={i} className="group relative isolate">
              {/* Back Glow */}
              <div
                className={`absolute -inset-4 bg-gradient-to-r ${gradient} -z-10 rounded-[40px] opacity-0 blur-xl transition-opacity duration-700 group-hover:opacity-20`}
              />

              {/* Main Glass Card */}
              <div className="relative h-full overflow-hidden rounded-[32px] border border-white/10 bg-white/[0.03] p-6 shadow-2xl backdrop-blur-md transition-all duration-500 group-hover:border-white/20 sm:p-8">
                {/* Internal Reflection */}
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                <div className="relative z-10">
                  <div
                    className={`h-14 w-14 rounded-2xl bg-gradient-to-br ${gradient} mb-6 p-[1px] shadow-lg shadow-black/50`}
                  >
                    <div className="flex h-full w-full items-center justify-center rounded-2xl bg-[#0c1220]/80 backdrop-blur-sm">
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                  </div>

                  <h3 className="home-card-title-sm mb-4 leading-tight text-white">{item.name}</h3>
                  <p className="home-subnote leading-relaxed text-gray-400">{item.desc}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
